export const EXPANDED_FOLDER_PLACEHOLDER = {
  EMPTY: 'empty',
  NO_MATCHES: 'noMatches',
} as const;

export type ExpandedFolderPlaceholder =
  typeof EXPANDED_FOLDER_PLACEHOLDER[keyof typeof EXPANDED_FOLDER_PLACEHOLDER];

export const EXPANDED_FOLDER_PLACEHOLDER_LABELS: {
  [key in ExpandedFolderPlaceholder]: string;
} = {
  [EXPANDED_FOLDER_PLACEHOLDER.EMPTY]: 'This folder is empty.',
  [EXPANDED_FOLDER_PLACEHOLDER.NO_MATCHES]: 'No matching files.',
};

export const DOCUMENTS_TABLE_ROW_KIND = {
  FOLDER: 'folder',
  FILE: 'file',
  PLACEHOLDER: 'placeholder',
} as const;

export type DocumentsTableRowKind =
  typeof DOCUMENTS_TABLE_ROW_KIND[keyof typeof DOCUMENTS_TABLE_ROW_KIND];
